"use client";

import { useEffect, useRef } from "react";

/**
 * Locks document scroll while `active` (mobile-friendly: position fixed + restore scroll).
 */
export function useBodyScrollLock(active: boolean) {
  const savedScrollY = useRef(0);

  useEffect(() => {
    if (!active) return;

    savedScrollY.current = window.scrollY;
    const body = document.body;
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${savedScrollY.current}px`;
    body.style.left = "0";
    body.style.right = "0";

    return () => {
      const scrollY = savedScrollY.current;
      body.style.overflow = "";
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      // Instant restore avoids visible scroll animation from global scroll-behavior: smooth.
      window.scrollTo({ top: scrollY, left: 0, behavior: "instant" });
    };
  }, [active]);
}
